import { render, staticRenderFns } from "./footer_information.vue?vue&type=template&id=75041dd0&scoped=true&"
import script from "./footer_information.vue?vue&type=script&lang=js&"
export * from "./footer_information.vue?vue&type=script&lang=js&"
import style0 from "./footer_information.vue?vue&type=style&index=0&id=75041dd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75041dd0",
  null
  
)

export default component.exports